<template>
    <div class="common-comp">
        <p class="icon-box"
           :class="{
                disabled: alwaysEnabled,
                'audio-word': ['AudioWord'].includes(type)
            }"
           @click="handleEnabled">
            <span v-if="type === 'AudioSelect'" class="icon-type">
                <span v-if="enabled" class="iconfont icon-yinpingaoliang" style="font-size: 18px"></span>
                <span v-else class="disabled iconfont icon-yinpinjinyong" style="font-size: 18px"></span>
            </span>
            <span v-else-if="type === 'ImageSelect'" class="icon-type">
                <span v-if="enabled" class="iconfont icon-tupiangaoliang"></span>
                <span v-else class="disabled iconfont icon-tupianjinyong"></span>
            </span>
            <span v-else-if="type === 'VideoSelect'" class="icon-type">
                <span v-if="enabled" class="iconfont">
                    <img :src="$images.material.shipingaoliang" />
                </span>
                <span v-else class="disabled iconfont">
                    <img :src="$images.material.shipinjinyong" />
                </span>
            </span>
            <span v-else-if="type === 'TextInput'" class="icon-type">
                <span v-if="enabled" class="iconfont icon-wenzigaoliang"></span>
                <span v-else class="disabled iconfont icon-wenzijinyong"></span>
            </span>
            <span v-else-if="type === 'AudioWord'" class="icon-type">
                <span v-if="enabled" class="iconfont icon-wenzigaoliang"></span>
                <span v-else class="disabled iconfont icon-wenzijinyong"></span>
            </span>
            <span v-else-if="type === 'BackgroundSelect'" class="icon-type">
                <span v-if="enabled" class="iconfont icon-beijing"></span>
                <span v-else class="disabled iconfont icon-beijing"></span>
            </span>
            <span v-else-if="type === 'AnimationSelect'" class="icon-type">
                <span v-if="enabled" class="iconfont icon-donghua"></span>
                <span v-else class="disabled iconfont icon-donghua"></span>
            </span>
        </p>
        <p
            v-if="['AudioWord'].includes(type)?true: enabled"
            class="txts"
            :class="{
                'audio-word': ['AudioWord'].includes(type),
                'disabled': !audioEnabled
            }"
        >
            <el-tooltip
                    class="item"
                    effect="light"
                    :content="warnTip"
                    placement="bottom"
                    :disabled="!warnTip || warnDisabled"
            >
                <span
                    v-if="['TextInput', 'AudioWord'].includes(type)"
                    class="txt-type"
                    :class="{'word-audio': ['AudioWord'].includes(type)}"
                >
                    <el-input
                        class="input"
                        :class="{
                            audioWord: ['AudioWord'].includes(type),
                            disabled: !enabled,
                            allDisabled: !audioEnabled
                        }"
                        :clearable="true"
                        v-model="newValue"
                        placeholder="请输入内容"
                        @focus="onFocus"
                        @blur="setSendKeyBoardToCocos({key: 'txtType', value: true})"
                        @input.native="handlerChange"
                        @clear="handlerChange"
                    />
                    <el-input
                        v-if="isFocus"
                        ref="textarea"
                        class="input textarea"
                        :class="{
                            focus: isFocus,
                            audioWord: ['AudioWord'].includes(type),
                            disabled: !enabled,
                            allDisabled: !audioEnabled
                        }"
                        type="textarea"
                        :clearable="true"
                        v-model="newValue"
                        placeholder="请输入内容"
                        @blur="onBlur"
                        @input.native="handlerChange"
                        @clear="handlerChange"
                    />
                    <span v-if="['AudioWord'].includes(type)"
                          class="audio-select"
                          :class="{alwaysAudioEnabled}"
                          @click="handleAudioEnabled"
                    >
                        <span v-if="audioEnabled" class="iconfont icon-yinpingaoliang"></span>
                        <span v-else class="iconfont icon-yinpinjinyong" style="color: #A8AAAD;"></span>
                    </span>
                </span>
                <span
                    v-else class="txt-type"
                    @click="selectResource"
                >
                    <span v-if="!name" class="txt">
                        <span class="iconfont icon-shangchuan"></span>
                        <span class="warn">上传文件</span>
                    </span>
                    <span v-else class="txt">
                        <span v-if="type==='AudioSelect' && value"
                              class="audio-ico"
                              @click.stop="handleAudio"
                        >
                            <span v-if="newStatus === 'on'" class="iconfont icon-bofang"></span>
                            <span v-else class="iconfont icon-zanting"></span>
                        </span>
                        <span class="name">{{name}}</span>
                    </span>
                </span>
            </el-tooltip>
        </p>

        <!--文音组件-->
        <span
            v-if="['AudioWord'].includes(type) && audioEnabled"
            class="audio-word-box"
            @click="selectResource"
        >
            <span v-if="!audioName" class="txt empty">
                <span class="iconfont icon-shangchuan"></span>
                <span class="warn">上传文件</span>
            </span>
            <span v-else class="txt">
                <span
                    class="audio-ico"
                    @click.stop="handleAudio"
                >
                    <span v-if="newStatus === 'off'"  class="iconfont icon-zanting"></span>
                    <span v-else class="iconfont icon-bofang"></span>
                </span>
                <span class="name">{{audioName}}</span>
            </span>
        </span>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {AudioPlay2, AudioPause} from "../../../../../../../../../../utils/audio";

    export default {
        name: "CommonComp",
        props: {
            inputType: {
                type: String,
                default: 'text'
            },
            type: String,
            alwaysEnabled: Boolean,
            alwaysAudioEnabled: Boolean,
            enabled: Boolean,
            title: String,
            name: String,
            value: [String, Number],
            placeholder: String,
            status: String,
            length: [String, Number],
            parentId: [String, Number],
            index: [String, Number],
            audioName: String,
            audioSrc: String,
            audioEnabled: Boolean,
            warnTip: String,
            warnDisabled: Boolean,
            __trimPathById: [String, Number]
        },
        watch:{
            value(vl){this.newValue = vl},
            newValue(vl){this.$emit('update:value', vl)},
            status(vl){this.newStatus = vl},
            newStatus(vl){this.$emit('update:status',vl)},
        },
        data(){
            return {
                isFocus: false, // 是否选中状态
                newValue: this.value,
                newStatus: this.status
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos', 'setOperationQueue']),
            onFocus(){
                this.handleMouseEnterOpen();
                this.setSendKeyBoardToCocos({key: 'txtType', value: false})

                const operationQueue = []
                operationQueue.push({id: this.parentId, path: `/components/${this.index}/focus`, data: null, operation: 'REFRESH', oneWay: true})
                this.setOperationQueue(operationQueue)

                // 如果文本框支持多行输入
                if(['textarea'].includes(this.inputType)) {
                    // 焦点在文本框内
                    this.isFocus = true
                    setTimeout(() => {
                        this.$refs.textarea.focus()
                    })
                }

            },
            onBlur(){
                this.setSendKeyBoardToCocos({key: 'txtType', value: true})

                // 如果文本框支持多行输入
                if(['textarea'].includes(this.inputType)) {
                    // 焦点离开文本框
                    this.isFocus = false
                }
            },
            // 音频启用/禁用
            handleAudioEnabled(){
                if(this.alwaysAudioEnabled){
                    return false
                }
                const operationQueue = []
                operationQueue.push({id: this.parentId, path: `/components/${this.index}/audioEnabled`, data: !this.audioEnabled, operation: 'REPLACE', oneWay: false})
                this.setOperationQueue(operationQueue)
            },
            // 启用/禁用
            handleEnabled(){
                if(this.alwaysEnabled){
                    return false
                }

                console.log('启用/禁用', this.enabled)
                this.$emit('onBtns', {ObjectKeyValue: {key: 'enabled', value: !this.enabled}})
            },
            handlerChange(e){
                this.$emit('onBtns', {value: e?.target?.value || '', oneWay: true})
            },
            selectResource(){
                let type = ''
                let obj = {}
                console.log('retro1119-51', this.type)
                switch (this.type) {
                    case 'AudioSelect':
                        type = 'audio'
                        obj.selfFlag = {
                            type: this.type
                        }
                        console.log('retro1119-5', this.newStatus)
                        // 如果当前音频文件正在播放则关闭当前音频
                        if(this.newStatus === 'off'){
                            this.newStatus = 'on'
                            this.toCocosPlayOrPauseAudio(false)
                            AudioPause()
                        }
                        break
                    case 'AudioWord':
                        type = 'audio'
                        // 音文组件 配置
                        obj.selfFlag = {
                            type: this.type,
                            content: this.value,
                            audioName: this.audioName,
                            audioSrc: this.audioSrc,
                            audioEnabled: this.audioEnabled
                        }
                        if(this.newStatus === 'off'){
                            this.newStatus = 'on'
                            this.toCocosPlayOrPauseAudio(false)
                            AudioPause()
                        }
                        break
                    case 'VideoSelect':
                        type = 'video'
                        break
                    case 'ImageSelect':
                    case 'BackgroundSelect':
                        type = 'image'
                        break
                    case 'AnimationSelect':
                        type = 'animation'
                        break
                }
                this.$emit('onBtns', {value: this.newValue, type: 'focus'})

                obj.type = 'EditResource'
                obj.value = {type}
                obj.callback = { type:'EditGameConfig', id: this.parentId, path: `/components/${this.index}`, operation: 'REPLACE'}
                this.$toWebMessage(obj)
            },
            handleAudio(){
                console.log('type==>', this.type, this.newStatus)
                const url = `${this.type}` === 'AudioWord'?this.audioSrc:this.value
                if(this.newStatus === 'off'){
                    this.newStatus = 'on'
                    this.toCocosPlayOrPauseAudio(false)
                    // this.value && AudioPause()
                } else {
                    this.newStatus = 'off'
                    this.toCocosPlayOrPauseAudio(true)
                    AudioPlay2({url, endCallBack: ()=>{
                            this.newStatus = 'on'
                            this.toCocosPlayOrPauseAudio(false)
                        }})
                }
            },
            // 同步cocos侧 当前正在播放的音频参数
            toCocosPlayOrPauseAudio(state){
                // flag标识这个编辑是项目本身修改
                const data = state?{[this.__trimPathById]:{rowId: this.parentId, componentPath: '/components/'+ this.index, from: 'plat'}} : null
                this.$store.state.editGameConfig.audio = {
                    playing: data
                }
                const operationQueue = [
                    {
                        path: `/audio/playing`,
                        data,
                        operation: 'REPLACE',
                        oneWay: data?true: false
                    }
                ]
                this.setOperationQueue(operationQueue)
            },
            handleMouseEnterOpen(){
                this.$store.state.menusKeyBoard=false;//当前是可操作焦点
            },
        }
    }
</script>

<style lang="scss" scoped>
.common-comp{
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;

    .icon-box{
        width: 32px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 4px;
        text-align: center;
        line-height: 32px;
        flex-shrink: 0;

        &.audio-word{
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            position: relative;

            &:before{
                content: '';
                position: absolute;
                right: 0px;
                top: 9px;
                width: 1px;
                height: 16px;
                background: #E0E1E4;
            }
        }

        &.disabled{
            cursor: default;
        }
        .disabled{
            color: #A8AAAD;
        }
    }

    .txts{
        display: flex;
        flex-direction: row;
        align-items: center;
        border-radius: 4px;
        height: 32px;
        background-color: white;
        margin-left: 8px;
        flex-shrink: 0;

        &.audio-word{
            border-radius: 0;
            margin-left: 0px;

            &.disabled{
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;

                .audio-select:before{
                    display: none;
                }
            }

            /deep/ input{
                padding-left: 8px;
            }
        }

        .input{
            /deep/ .el-input__inner{
                border: none;
                outline: none;
                height: 32px;
                line-height: 32px;
            }

            &.textarea{
                position: absolute;
                height: 121px;
                top: 8px;
                z-index: 100001;

                /deep/ textarea{
                    height: 100%;
                    resize: none;
                }
            }
            &.audioWord.textarea{
                position: absolute !important;
                width: calc(100% - 40px);
                padding-right: 0px;
            }
        }
        .txt-type{
            display: flex;
            flex-direction: row;
            align-items: center;
            position: relative;

            .item{
                display: flex;
                height: 32px;
            }

            .txt {
                .audio-ico {
                    .iconfont{
                        transition: all .2s linear;
                    }
                    &:hover {
                        .iconfont {
                            opacity: .8;
                            font-size: 18px;
                        }
                    }
                }
            }

            &.word-audio /deep/ .el-input__suffix{
                position: absolute;
                right: 46px;
                width: 20px;
                height: 20px;
            }

            &.word-audio /deep/ .el-input--suffix .el-input__inner{
                padding-right: 50px;
            }

            .input.audioWord{
                padding-right: 18px;
                position: relative;

                &.disabled{
                    width: 20px;
                    overflow: hidden;

                    &.allDisabled /deep/ input{
                        width: 0px;
                        padding-right: 0;
                    }
                }

                &:before{
                    content: '';
                    position: absolute;
                    right: 40px;
                    top: 16px;
                    width: 1px;
                    height: 16px;
                    background: #E0E1E4;
                }
                &.focus:before{
                    content: none;
                }
            }

            .audio-select{
                position: absolute;
                top: 0px;
                right: 20px;
                width: 20px;
                height: 20px;
                display: inline-block;
                /*background-color: red;*/

                &.alwaysAudioEnabled{
                    cursor: initial;
                }

                &:before{
                    content: '';
                    position: absolute;
                    right: -20px;
                    top: 16px;
                    width: 1px;
                    height: 16px;
                    background: #E0E1E4;
                }

                .icon-yinpinjinyong1{
                    color: #B2B4B7;
                }
            }
        }

        .iconfont{
            margin-left: 12px;
        }
        .name{
            color: #5CB87A;
        }
        .warn,.name{
            margin-left: 8px;
            margin-right: 12px;
        }
    }

    .audio-word-box{
        background-color: white;
        height: 32px;
        line-height: 32px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        padding: 0px 12px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .audio-ico:hover{
            opacity: .8;
        }

        .name{
            margin-left: 10px;
            color: #5CB87A;
        }

        .txt.empty {

            .name {
                margin-left: 0px;
                color: #5CB87A;
            }

            .warn, .name {
                margin-left: 8px;
            }
        }
    }
}
</style>